export default "__VITE_ASSET__lRehwoj___"